import { render, staticRenderFns } from "./licationSettle.vue?vue&type=template&id=552504b4"
import script from "./licationSettle.vue?vue&type=script&lang=js"
export * from "./licationSettle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports